import React from 'react';
import { Link } from 'react-router-dom';
import { Text, Title1, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    minHeight: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    padding: '40px',
    textAlign: 'center',
  },
  description: {
    color: tokens.colorNeutralForeground3,
  },
  link: {
    color: tokens.colorBrandForegroundLink,
  },
});

const NotFoundPage: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Title1>404</Title1>
      <Text size={500} weight="semibold">Page not found</Text>
      <Text className={styles.description}>
        The page you&apos;re looking for doesn&apos;t exist.
      </Text>
      <Link className={styles.link} to="/overview">Go to Overview</Link>
    </div>
  );
};

export default NotFoundPage;